<template>
  <div id="app">
    <navbar></navbar>
    <router-view />
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Navbar from "@/components/Navbar.vue"
export default {
  components: {
    Navbar
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Poppins:400,400i,500,700,900');
#app {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size: 15px;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

/* Form button styles */
.submit-btn {
  border-radius: 3px;
  min-width: 80px;
  background-color: #DA2A2A;
}

.submit-btn:hover {
  background-color: #a32626;
}

.cancel-btn {
  border-radius: 3px;
  min-width: 80px;
  background-color: #b5b3b3;
}

.cancel-btn:hover {
  background-color: #919090;
}

h1 {
  font-weight: 700;
}

.page-item.active .page-link {
    background-color: #DA2a2a;
    border-color: #DA2a2a;
}

</style>
